module.exports = __webpack_public_path__ + "static/media/off.4e6d1b88.svg";